import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { podeAcessarRota, rotaInicialPorPerfil } from '../auth/perfil-acesso';

interface PerfilRouteProps {
  routePath: string;
  children: ReactNode;
}

export default function PerfilRoute({ routePath, children }: PerfilRouteProps) {
  const { usuario } = useAuth();
  const tipoUsuario = usuario?.tipo_usuario;

  if (!podeAcessarRota(tipoUsuario, routePath)) {
    return <Navigate to={rotaInicialPorPerfil(tipoUsuario)} replace />;
  }

  return <>{children}</>;
}
